module.exports = __webpack_public_path__ + "static/media/copyCheckout.4bf4e593.svg";